import { inject } from '@angular/core';
import { Router, CanActivateChildFn, ActivatedRouteSnapshot } from '@angular/router';
import { PermissionService } from '@/app/core/services/permission/permission.service';
import { environment } from '@/environments/environment';

export const permissionGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot) => {
  // TEMP: allow viewing modules without permission checks while keeping guard for later.
  if (environment.featureFlags?.bypassAuth) return true;

  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const requiredPermissions = route.data?.['PERMISSION_LIST'] as string[] | undefined;
  const agentOnly = route.data?.['AGENT_ONLY'] === true;
  const strictPermissions = route.data?.['STRICT_PERMISSION'] === true;

  if (!requiredPermissions?.length) {
    if (!agentOnly) {
      return true;
    }
  }

  if (agentOnly && !permissionService.isAgentLogin()) {
    const redirectPath = permissionService.getFirstAccessibleRoute();
    return router.createUrlTree([redirectPath]);
  }

  const hasAccess = strictPermissions
    ? permissionService.hasAnyExact(requiredPermissions ?? [])
    : permissionService.hasAny(requiredPermissions ?? []);
  if (requiredPermissions?.length && !hasAccess) {
    const redirectPath = permissionService.getFirstAccessibleRoute();
    return router.createUrlTree([redirectPath]);
  }

  return true;
};
